<template>
  <NewHouseLayout>
    <div class="nh-page">
    <div class="nh-tabs">
      <div
        :class="['nh-tab', { active: activeTab === 'my' }]"
        @click="activeTab = 'my'"
      >
        我的办理
      </div>
      <div
        :class="['nh-tab', { active: activeTab === 'add' }]"
        @click="activeTab = 'add'"
      >
        新增申请
      </div>
    </div>

    <div v-if="activeTab === 'my'" class="nh-list">
      <div
        v-for="item in myApplications"
        :key="item.id"
        class="nh-card-item"
        @click="handleItemClick(item)"
      >
        <div class="nh-card-header">
          <div class="nh-card-title">
            <span class="project-name">{{ item.xmmc }}</span>
            <span class="room-no">{{ item.fh }}</span>
          </div>
          <span :class="['status-tag', item.status === '1' ? 'done' : 'processing']">
            {{ item.status === '1' ? '已完成' : '办理中' }}
          </span>
        </div>
        <div class="nh-card-body">
          <p><span class="label">办理事项：</span>{{ item.dbsx_qb || '—' }}</p>
          <p><span class="label">已 完 成：</span>{{ item.dbsx_wc || '—' }}</p>
          <p><span class="label">提交时间：</span>{{ item.create_time }}</p>
        </div>
      </div>
      <el-empty v-if="!loading && myApplications.length === 0" description="暂无办理记录" />
    </div>

    <div v-else class="nh-add">
      <p class="nh-tip">点击下方按钮开始一次新的新房购置一件事申请。</p>
      <el-button
        type="danger"
        size="large"
        class="nh-add-btn"
        @click="handleAdd"
      >
        新增申请
      </el-button>
    </div>
  </div>
  </NewHouseLayout>
</template>

<script setup>
import NewHouseLayout from './layout.vue';
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getMyBusinessListRe } from '@/api/newHouse';
import { decodeData } from '@/utils/decodeData';

const router = useRouter();
const activeTab = ref('my');
const loading = ref(false);
const myApplications = ref([]);

const fetchList = async () => {
  loading.value = true;
  try {
    // res 是 axios 完整 response，res.data 是后端 {code, msg, data}
    // data 字段是 URL 编码 + JSON 字符串，decodeData 解析成业务数组
    const res = await getMyBusinessListRe();
    const decoded = decodeData(res?.data);
    const list = Array.isArray(decoded) ? decoded : (decoded?.data || []);
    myApplications.value = list;
  } catch (e) {
    myApplications.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  fetchList();
});

const handleAdd = () => {
  router.push({ name: 'newHouseSelectBusiness' });
};

// 卡片点击打开业务详情
const handleItemClick = (item) => {
  if (!item?.id) return;
  router.push({
    name: 'newHouseBusinessDetail',
    query: { ywId: item.id, htbh: item.htbh || '' },
  });
};
</script>

<style lang="scss" scoped>
.nh-page {
  background: #ffffff;
  padding: 0 0 24px;
}

.nh-tabs {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0d9d9;
  padding: 0 24px;
  background: #ffffff;
}

.nh-tab {
  position: relative;
  padding: 18px 16px;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  cursor: pointer;
  margin-right: 32px;

  &.active {
    color: #bd1a2d;

    &::after {
      content: '';
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: -1px;
      height: 3px;
      background: #bd1a2d;
      border-radius: 2px;
    }
  }
}

.nh-list {
  padding: 16px 24px;
}

.nh-card-item {
  border: 1px solid #f0d9d9;
  border-radius: 6px;
  padding: 20px 24px;
  margin-bottom: 16px;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: #bd1a2d;
    box-shadow: 0 2px 8px rgba(189, 26, 45, 0.1);
  }
}

.nh-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 1px dashed #eee;
}

.nh-card-title {
  display: flex;
  align-items: center;
  gap: 24px;
}

.project-name {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.room-no {
  font-size: 14px;
  color: #666;
}

.status-tag {
  font-size: 12px;
  padding: 2px 12px;
  border-radius: 999px;
  border: 1px solid transparent;

  &.processing {
    color: #2f7cf6;
    background: #e8f1ff;
    border-color: #c8dcff;
  }

  &.done {
    color: #15a36b;
    background: #e6f7f0;
    border-color: #b8e6d2;
  }
}

.nh-card-body {
  padding-top: 12px;

  p {
    margin: 4px 0;
    font-size: 14px;
    color: #4a4a4a;
    line-height: 1.8;
  }

  .label {
    color: #888;
    margin-right: 4px;
  }
}

.nh-add {
  padding: 48px 24px;
  text-align: center;
}

.nh-tip {
  font-size: 14px;
  color: #666;
  margin: 0 0 24px;
}

.nh-add-btn {
  width: 200px;
  height: 44px;
  font-size: 16px;
  background: #bd1a2d;
  border-color: #bd1a2d;
}
</style>
